import z from 'zod';
export var validator = z.object({
    _key: z.string()
});
export default {
    validator: validator
};

//# sourceMappingURL=arrayEntry.js.map